import { render, staticRenderFns } from "./ChangeInform.vue?vue&type=template&id=087d52b7&scoped=true&"
import script from "./ChangeInform.vue?vue&type=script&lang=js&"
export * from "./ChangeInform.vue?vue&type=script&lang=js&"
import style0 from "./ChangeInform.vue?vue&type=style&index=0&id=087d52b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d52b7",
  null
  
)

export default component.exports